(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faceted-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  /* Phones: the "Show … cushions" button closes Symmetry's filter panel. */
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const show = event.target.closest('.ip-filter-show');
    if (!show) return;
    event.preventDefault();
    const button = document.querySelector('.utility-bar [data-toggle-filters]');
    if (button) {
      button.click();
      setTimeout(() => button.focus({ preventScroll: true }), 60);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
